import styled from "styled-components";

import {
	DESKTOP_SM_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	MOBILE_L_BP,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 45px;
	align-items: center;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 45px 0px 50px 0px;
	}
`;

export const Title = styled.div`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 33px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;
`;

export const FilterBar = styled.div`
	margin-bottom: 95px;
	display: flex;
	position: absolute;
	margin-top: 60px;
	padding-right: 145px;
	margin-left: 145px;
	flex-wrap: wrap;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 10px;
		margin-left: unset;
		justify-content: center;
		position: unset;
		margin-bottom: unset;
		margin-top: 35px;
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		margin-left: unset;
		padding-right: unset;
		justify-content: center;
	}
`;

export const SelectWrapper = styled.div`
	margin-left: 2px;
	margin-right: 2px;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		margin-top: 6px;
		margin-bottom: 6px;
	}
`;

export const CardsContainer = styled.div`
	display: flex;
	width: 760px;
	flex-wrap: wrap;
	margin-top: 150px;
	justify-content: center;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		display: flex;
		flex-wrap: wrap;
		margin-top: 35px;
		margin-bottom: 20px;
		width: 100%;
	}
`;

export const LoadMore = styled.span`
	margin-top: 30px;
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 16px;
	line-height: 20px;
	cursor: pointer;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const ClearFilters = styled.div`
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	top: 0;
	right: 0;
	height: 60px;
	cursor: pointer;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		position: unset;
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		position: unset;
	}
`;
export const ClearFilterText = styled.span`
	font-weight: ${FONT_WT_LIGHT};
	font-size: 16px;
	line-height: 19px;
	/* margin-top: 19px; */
	margin-left: 10px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const CrossIcon = styled.div`
	display: inline;
	/* margin-top: 19px; */

	picture {
		img {
			height: 19px;
		}
	}
`;

export const NoResults = styled.span`
	text-align: center;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-weight: 500;
	margin-bottom: 40px;
`;
